export default __webpack_public_path__ + "static/branch02-753c49d17099defbfaa71b69089324df.jpg";